import React, { useEffect } from 'react'
import PartiTable from 'components/Shared/MuiTable/PartiTable'
import {
    getCampaignOverviewColumnsDef,
    getCampaignOverviewRowsDef,
    CampaignOverviewRowProps,
} from './CampaignOverviewTableDef'
import {
    getCampaignPerformanceColumnsDef,
    getCampaignPerformanceRowsDef,
    CampaignPerformanceRowProps,
} from './CampaignPerformanceTableDef'
import { TableViewType } from 'components/Shared/MuiTable'
import styled from 'styled-components'
import { CampaignState } from 'state/campaigns'
import { useNewTranslation } from 'hooks'
import { ReportSummaryContainer } from '../../utils'
import { useDispatch, useSelector } from 'react-redux'
import {
    getCampaignOverview,
    getCampaignPerformance,
    selectCampaignOverview,
    selectCampaignPerformance,
} from 'state/campaignReport'
import { STATE_KEYS } from 'state/requests'
import { selectRequestsAreLoading } from 'state'
import { ReportContainer } from 'components/Submissions/Review/Report/styles'
interface OverviewProps {
    campaign: CampaignState
}

const Overview: React.FC<OverviewProps> = ({ campaign }) => {
    const [t] = useNewTranslation()
    const dispatch = useDispatch()
    const campaignOverview = useSelector(selectCampaignOverview)
    const campaignPerformance = useSelector(selectCampaignPerformance)
    const iscampaignOverviewLoading = useSelector(selectRequestsAreLoading([STATE_KEYS.GetCampaignOverview]))
    const isCampaignPerformanceLoading = useSelector(selectRequestsAreLoading([STATE_KEYS.GetCampaignPerformance]))

    useEffect(() => {
        dispatch(getCampaignOverview({ uuid: campaign.uuid }))
        dispatch(getCampaignPerformance({ uuid: campaign.uuid }))
    }, [campaign.uuid])

    const campaignOverviewColumns = getCampaignOverviewColumnsDef()
    const campaignOverviewRows = getCampaignOverviewRowsDef(campaignOverview, campaign)

    const campaignPerformanceColumns = getCampaignPerformanceColumnsDef()
    const campaignPerformanceRows = getCampaignPerformanceRowsDef(campaignPerformance, campaign)

    return (
        <ReportContainer>
            <ReportSummaryContainer title={t('submission.exportList.campaignOverview')}>
                <TableContainer>
                    <PartiTable
                        tableHeight="auto"
                        viewType={TableViewType.CAMPAIGN_OVERVIEW}
                        headerHeight={36}
                        rowHeight={56}
                        columns={campaignOverviewColumns}
                        rows={campaignOverviewRows as CampaignOverviewRowProps[]}
                        isLoading={iscampaignOverviewLoading}
                        hideToolbar
                        disableColumnMenu
                        hideFooter
                        noPadding
                        hideTableBorder
                        isNewStyle
                    />
                </TableContainer>
            </ReportSummaryContainer>
            <ReportSummaryContainer title={'Campaign Performance'}>
                <TableContainer>
                    <PartiTable
                        tableHeight="auto"
                        viewType={TableViewType.CAMPAIGN_PERFORMANCE}
                        headerHeight={36}
                        rowHeight={campaignPerformanceRows.length - 1 ? 36 : 56}
                        getRowHeight={params => {
                            if (params.id === campaignPerformanceRows[campaignPerformanceRows.length - 1].id) return 36
                            return 56
                        }}
                        columns={campaignPerformanceColumns}
                        rows={campaignPerformanceRows as CampaignPerformanceRowProps[]}
                        isLoading={isCampaignPerformanceLoading}
                        hideToolbar
                        disableColumnMenu
                        hideFooter
                        noPadding
                        hideTableBorder
                        isNewStyle
                        getRowClassName={params => {
                            if (params.id === campaignPerformanceRows[campaignPerformanceRows.length - 1].id)
                                return 'row-total'
                            return ''
                        }}
                    />
                </TableContainer>
            </ReportSummaryContainer>
        </ReportContainer>
    )
}

export default Overview

const TableContainer = styled.div`
    width: 100%;
    .MuiDataGrid-columnHeaders {
        color: ${({ theme }) => theme.colors.text.primary};
        background: ${({ theme }) => theme.colors.surface.infoPastel};
    }

    .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeaderCheckbox) .MuiDataGrid-columnHeaderTitleContainer {
        margin-right: 0;
    }

    .new-style-MUI .MuiDataGrid-columnHeaderTitle {
        color: ${({ theme }) => theme.colors.text.primary};
    }

    .align-left-header {
        .MuiDataGrid-columnHeaderTitleContainerContent {
            margin-left: 2px;
        }
    }

    .MuiDataGrid-columnHeaderTitleContainerContent {
        margin: auto;
    }

    .title-cell {
        background: ${({ theme }) => theme.colors.surface.infoPastel};
    }

    .row-total {
        align-items: center;
        background: ${({ theme }) => theme.colors.surface.tertiary};

        .title-cell {
            min-height: 36px;
            height: 36px;
            background: ${({ theme }) => theme.colors.surface.tertiary};
        }
    }

    .row-total .MuiDataGrid-cell {
        > *:last-child {
            font-weight: 700;

            .cellValue {
                font-weight: 700;
            }
        }
    }
`
